import React from 'react';
import 'intl-tel-input/styles';
import { normalizeCountryCode } from '../../../services/countries';
import styles from './CountryFlag.module.css';

const sizeClassMap = {
  sm: styles.sm,
  md: styles.md,
  lg: styles.lg,
};

const normalizeSize = (size) => {
  if (size === 'sm' || size === 'lg') return size;
  return 'md';
};

export const CountryFlag = ({ countryCode, size = 'md', className = '' }) => {
  const normalizedCode = normalizeCountryCode(countryCode);
  if (normalizedCode.length !== 2) return null;

  const iso2 = normalizedCode.toLowerCase();
  const normalizedSize = normalizeSize(size);
  const sizeClassName = sizeClassMap[normalizedSize];

  return (
    <span className={`${styles.flag} ${sizeClassName} ${className}`.trim()}>
      <span className={`iti__flag iti__${iso2} ${styles.sprite}`} aria-hidden="true" />
    </span>
  );
};
